export default __webpack_public_path__ + "static/media/Stamp.5e8e05ef.svg";